import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
// Formik
import { useFormikContext } from 'formik';
// Elements
import Label from '../elements/Label';
import Error from '../elements/Error';
const inputTypes = {
  website: 'url'
};
const ListField = ({ formik = {}, hasError = false, fieldId, data }) => {
  const { handleChange, handleBlur, values } = useFormikContext();
  const type = data.type.toLowerCase();
  const [amount, setAmount] = useState([
  {
    value: '',
    label: `${fieldId}_1`,
    id: 1
  }]
  );
  useEffect(() => {
    const arr = [];
    amount.forEach((item) => {
      arr.push(values[item.label]);
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    values[fieldId] = arr;
  }, [amount, values, fieldId]);
  // Conditional logic
  if (data.conditionalLogic) {
    // Whether or not to show the field
    if (data.conditionalLogic.actionType === 'SHOW') {
      let show = true;
      data.conditionalLogic.rules.forEach((rule) => {
        if (rule.operator === 'IS') {
          if (values[`input_${rule.fieldId}`] !== rule.value) {
            show = false;
          }
        }
        if (rule.operator === 'IS_NOT') {
          if (values[`input_${rule.fieldId}`] === rule.value) {
            show = false;
          }
        }
      });
      if (!show) {
        return null;
      }
    }
  }
  return _jsxs("div", { className: `form-duuf-group form-duuf-group-${type}${data.cssClass ? ` ${data.cssClass}` : ''}`, children: [_jsx(Label, { fieldId: fieldId, data: data }), _jsx(Error, { fieldId: fieldId, data: data, hasError: hasError, formik: formik }), amount.map((item, index) => _jsxs("div", { className: "flex items-center gap-3", children: [_jsx("input", { className: `form-duuf-input form-duuf-input-${type}`, type: inputTypes[type] || type, id: item.label, name: item.label, placeholder: data.placeholder, onBlur: handleBlur, onChange: handleChange, value: values[item.label] || '', maxLength: data.maxLength === 0 ? undefined : data.maxLength }), index + 1 === amount.length && _jsx("div", { onClick: () => {
          setAmount([
          ...amount,
          {
            value: '',
            label: `${fieldId}_${item.id + 1}`,
            id: item.id + 1
          }]
          );
        }, className: `form-duuf-group-${type}-add`, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1.5em", height: "1.5em", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", d: "M11 19v-6H5v-2h6V5h2v6h6v2h-6v6h-2Z" }) }) }), index > 0 && _jsx("div", { onClick: () => {
          const newValues = amount.filter((_, i) => i !== index);
          delete values[item.label];
          setAmount(newValues);
        }, className: `form-duuf-group-${type}-add`, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1.5em", height: "1.5em", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", d: "M19 12.998H5v-2h14z" }) }) })] }, index))] });
};
export default ListField;